<div class="appearance-tab-container" [formGroup]="formGroup">
  <div class="appearance-cards" formGroupName="appearance">
    <pdq-card variant="popover" color="white">
      <pdq-collapsed [initialCollapsed]="false" (onChange)="isContainerCollapsed = $event">
        <pdq-collapsed-header>
          <div class="section-header">
            <pdq-heading element="h6">Container</pdq-heading>
          </div>
          <pdq-collapsed-trigger>
            <pdq-icon
              class="collapse-arrow"
              [icon]="isContainerCollapsed ? 'collaping-arrow-down' : 'collapsing-arrow-up'"></pdq-icon>
          </pdq-collapsed-trigger>
        </pdq-collapsed-header>
        <pdq-collapsed-content>
          <div class="card-content" formGroupName="mainBackground">
            <pdq-divider></pdq-divider>
            <div class="flex-row">
              <pdq-dropdown formControlName="border" title="Border" [options]="borderOptions"></pdq-dropdown>
              <pdq-dropdown
                formControlName="borderWidth"
                title="Border Width"
                [options]="borderWidthOptions"></pdq-dropdown>
            </div>
            <div class="flex-row">
              <pdq-dropdown
                formControlName="cornerRadius"
                title="Corner radius"
                [options]="mainBackgroundCornerRadiusOptions"></pdq-dropdown>
              <pdq-dropdown formControlName="padding" title="Padding" [options]="paddingOptions"></pdq-dropdown>
            </div>
          </div>
        </pdq-collapsed-content>
      </pdq-collapsed>
    </pdq-card>

    <pdq-card variant="popover" color="white">
      <pdq-collapsed [initialCollapsed]="false" (onChange)="isImageCollapsed = $event">
        <pdq-collapsed-header>
          <div class="section-header">
            <pdq-heading element="h6">Image</pdq-heading>
          </div>
          <pdq-collapsed-trigger>
            <pdq-icon
              class="collapse-arrow"
              [icon]="isImageCollapsed ? 'collaping-arrow-down' : 'collapsing-arrow-up'"></pdq-icon>
          </pdq-collapsed-trigger>
        </pdq-collapsed-header>
        <pdq-collapsed-content>
          <div class="card-content" formGroupName="image">
            <pdq-divider></pdq-divider>
            <div class="flex-row">
              <pdq-dropdown formControlName="border" title="Border" [options]="borderOptions"></pdq-dropdown>
              <pdq-dropdown
                formControlName="borderWidth"
                title="Border Width"
                [options]="borderWidthOptions"></pdq-dropdown>
            </div>
            <div class="flex-row">
              <pdq-dropdown
                formControlName="cornerRadius"
                title="Corner radius"
                [options]="cornerRadiusOptions"></pdq-dropdown>
              <pdq-dropdown formControlName="padding" title="Padding" [options]="paddingOptions"></pdq-dropdown>
            </div>
          </div>
        </pdq-collapsed-content>
      </pdq-collapsed>
    </pdq-card>

    <pdq-card variant="popover" color="white">
      <pdq-collapsed [initialCollapsed]="false" (onChange)="isTitleCollapsed = $event">
        <pdq-collapsed-header>
          <div class="section-header">
            <pdq-heading element="h6">Title</pdq-heading>
          </div>
          <pdq-collapsed-trigger>
            <pdq-icon
              class="collapse-arrow"
              [icon]="isTitleCollapsed ? 'collaping-arrow-down' : 'collapsing-arrow-up'"></pdq-icon>
          </pdq-collapsed-trigger>
        </pdq-collapsed-header>
        <pdq-collapsed-content>
          <div class="card-content" formGroupName="titleText">
            <pdq-divider></pdq-divider>
            <rich-text-editor
              label="Label"
              placeholder="Upgrade Available"
              [control]="titleLabelControl"
              [invalidMsg]="titleLabelControl.getError('body_text_missmatch')"
              [config]="{
                items: dynamicFieldsAutocompleteOptions$ | async,
                triggerChar: richTextConfig.triggerChar,
                filterByKey: richTextConfig.filterByKey,
                removeTriggerCharOnSelect: richTextConfig.removeTriggerCharOnSelect,
                descriptionKey: richTextConfig.descriptionKey,
                variant: richTextConfig.variant,
              }">
            </rich-text-editor>
            <p class="hint-text">Dynamic fields available. Type {{ '{' }} to see options.</p>
            <pdq-dropdown formControlName="appearance" title="Appearance" [options]="appearanceOptions"></pdq-dropdown>
            <product-upgrade-badge-form
              title="Show badge on text"
              [formGroup]="titleBadge"
              [dynamicFieldsAutocompleteOptions$]="dynamicFieldsAutocompleteOptions$">
            </product-upgrade-badge-form>
          </div>
        </pdq-collapsed-content>
      </pdq-collapsed>
    </pdq-card>

    @if (!isFocusedStandalone) {
      <pdq-card variant="popover" color="white">
        <pdq-collapsed [initialCollapsed]="false" (onChange)="isUpgradeTextCollapsed = $event">
          <pdq-collapsed-header>
            <div class="section-header">
              <pdq-heading element="h6">Upgrade Text</pdq-heading>
            </div>
            <pdq-collapsed-trigger>
              <pdq-icon
                class="collapse-arrow"
                [icon]="isUpgradeTextCollapsed ? 'collaping-arrow-down' : 'collapsing-arrow-up'"></pdq-icon>
            </pdq-collapsed-trigger>
          </pdq-collapsed-header>
          <pdq-collapsed-content>
            <div class="card-content" formGroupName="upgradeText">
              <pdq-divider></pdq-divider>
              <rich-text-editor
                label="Label"
                placeholder="Upgrade to {upgrade_product_name}"
                [control]="upgradeLabelControl"
                [invalidMsg]="upgradeLabelControl.getError('body_text_missmatch')"
                [config]="{
                  items: dynamicFieldsAutocompleteOptions$ | async,
                  triggerChar: richTextConfig.triggerChar,
                  filterByKey: richTextConfig.filterByKey,
                  removeTriggerCharOnSelect: richTextConfig.removeTriggerCharOnSelect,
                  descriptionKey: richTextConfig.descriptionKey,
                  variant: richTextConfig.variant,
                }">
              </rich-text-editor>
              <p class="hint-text">Dynamic fields available. Type {{ '{' }} to see options.</p>
              <pdq-dropdown
                formControlName="appearance"
                title="Appearance"
                [options]="appearanceOptions"></pdq-dropdown>
              <product-upgrade-badge-form
                title="Show badge on text"
                [formGroup]="upgradeTextBadge"
                [dynamicFieldsAutocompleteOptions$]="dynamicFieldsAutocompleteOptions$">
              </product-upgrade-badge-form>
            </div>
          </pdq-collapsed-content>
        </pdq-collapsed>
      </pdq-card>
    }

    <pdq-card variant="popover" color="white">
      <pdq-collapsed [initialCollapsed]="false" (onChange)="isButtonsCollapsed = $event">
        <pdq-collapsed-header>
          <div class="section-header">
            <pdq-heading element="h6">Buttons</pdq-heading>
          </div>
          <pdq-collapsed-trigger>
            <pdq-icon
              class="collapse-arrow"
              [icon]="isButtonsCollapsed ? 'collaping-arrow-down' : 'collapsing-arrow-up'"></pdq-icon>
          </pdq-collapsed-trigger>
        </pdq-collapsed-header>
        <pdq-collapsed-content>
          <div class="card-content" formGroupName="button">
            <pdq-divider></pdq-divider>
            <p class="styling-subsection__subtitle">Button</p>
            <rich-text-editor
              label="Label"
              placeholder="Upgrade Available"
              [control]="buttonLabelControl"
              [invalidMsg]="buttonLabelControl.getError('body_text_missmatch')"
              [config]="{
                items: dynamicFieldsAutocompleteOptions$ | async,
                triggerChar: richTextConfig.triggerChar,
                filterByKey: richTextConfig.filterByKey,
                removeTriggerCharOnSelect: richTextConfig.removeTriggerCharOnSelect,
                descriptionKey: richTextConfig.descriptionKey,
                variant: richTextConfig.variant,
              }">
            </rich-text-editor>
            <p class="hint-text">Dynamic fields available. Type {{ '{' }} to see options.</p>
            <rich-text-editor
              label="Label for products with variants"
              placeholder="Upgrade Available"
              [control]="buttonVariantsLabelControl"
              [invalidMsg]="buttonVariantsLabelControl.getError('body_text_missmatch')"
              [disabledFormats]="buttonDisabledFormats"
              [config]="{
                items: dynamicFieldsAutocompleteOptions$ | async,
                triggerChar: richTextConfig.triggerChar,
                filterByKey: richTextConfig.filterByKey,
                removeTriggerCharOnSelect: richTextConfig.removeTriggerCharOnSelect,
                descriptionKey: richTextConfig.descriptionKey,
                variant: richTextConfig.variant,
              }">
            </rich-text-editor>
            <p class="hint-text">Dynamic fields available. Type {{ '{' }} to see options.</p>
            <pdq-dropdown
              formControlName="appearance"
              title="Button Appearance"
              [options]="appearanceOptions"></pdq-dropdown>
          </div>
        </pdq-collapsed-content>
      </pdq-collapsed>
    </pdq-card>

    @if (isFocusedStandalone) {
      <pdq-card variant="popover" color="white">
        <pdq-collapsed [initialCollapsed]="true" (onChange)="isCompletionBannerCollapsed = $event">
          <pdq-collapsed-header>
            <div class="section-header completion-banner__header">
              <pdq-heading element="h6">Final Banner</pdq-heading>
              <div class="completion-banner__header-right">
                <pdq-slide-toggle [formControl]="completionBannerEnabledControl" (click)="$event.stopPropagation()">
                </pdq-slide-toggle>
                <pdq-collapsed-trigger>
                  <pdq-icon
                    class="collapse-arrow"
                    [icon]="isCompletionBannerCollapsed ? 'collaping-arrow-down' : 'collapsing-arrow-up'"></pdq-icon>
                </pdq-collapsed-trigger>
              </div>
            </div>
          </pdq-collapsed-header>
          <pdq-collapsed-content>
            <div class="card-content" formGroupName="completionBanner">
              <pdq-divider></pdq-divider>
              <rich-text-editor
                label="Banner text"
                placeholder="Thanks for upgrading, {customer.firstName}!"
                [control]="completionBannerTextControl"
                [invalidMsg]="completionBannerTextControl.getError('body_text_missmatch')"
                [disabledFormats]="buttonDisabledFormats"
                [config]="{
                  items: dynamicFieldsAutocompleteOptions$ | async,
                  triggerChar: richTextConfig.triggerChar,
                  filterByKey: richTextConfig.filterByKey,
                  removeTriggerCharOnSelect: richTextConfig.removeTriggerCharOnSelect,
                  descriptionKey: richTextConfig.descriptionKey,
                  variant: richTextConfig.variant,
                }">
              </rich-text-editor>
              <p class="hint-text">Dynamic fields available. Type {{ '{' }} to see options.</p>
              <pdq-dropdown formControlName="tone" title="Tone" [options]="bannerToneOptions"></pdq-dropdown>
            </div>
          </pdq-collapsed-content>
        </pdq-collapsed>
      </pdq-card>
    }
  </div>
</div>
